<template>
  <div id="select-service-default-names">
    <input type="checkbox" class="blur-input" ref="inputBlur" placeholder="Teste" @blur="blurSelect" >
    <div class="block-input" @click="blockFrameClick" v-show="cx_blockInput && cx_isMobile && cx_iframeMode"></div>
    <v-select
      class="style-chooser"
      :class="{'iframe-mode': cx_iframeMode}"
      :id="!cx_selectedServiceDefaultName ? 'active-vs-search' : ''"
      :placeholder="placeholderTextDesktop"
      v-if="cx_ServiceDefaultNames"
      :options="cx_ServiceDefaultNames"
      :dropdown-should-open="dropdownShouldOpen"
      v-model="cx_selectedServiceDefaultName"
      @option:selected="changeSelect"
      @search:focus="vselectSearchFocus"
      @search:blur="vselectSearchBlur"
      label="search_name"
    >
      <template v-slot:option="option">
        <div class="d-flex justify-content-between">
          <div class="name-option open-sans-font">
            {{ option.search_name }}
          </div>
          <div class="info-option open-sans-font">
            <div v-if="$route.name != 'ClinicScreen'" class="title-info open-sans-font">
              Valor Médio
            </div>
            <div v-if="$route.name === 'ClinicScreen'" class="title-info open-sans-font">
              Pague na Farmácia
            </div>
            {{ formatCurrency(option.avg_price) }}
          </div>
        </div>
      </template>
      <template #no-options>
        <span class="open-sans-font">Não foram encontrados serviços</span>
      </template>
    </v-select>

    <div class="mobile-input">
      <input
        type="text"
        class="form-control open-sans-font"
        :placeholder="placeholderTextMobile"
        :value="!!cx_selectedServiceDefaultName ? cx_selectedServiceDefaultName.search_name : ''"
        v-on:focus="toogleSearchModal"
      />
    </div>
    <div class="mobile-search-modal" v-if="cx_isOpenMobileModal">
      <div
        class="mobile-modal-header"
        :class="{
          colorTenancy: $route.name == 'Tenancy' || $route.name == 'SearchServicesTenancy',
        }"
      >
        <div class="logo img-fluid" @click="returnHome()">
          <img :src="cx_logo" loading="lazy" />
        </div>
      </div>
      <div class="mobile-modal-body">
        <div class="mobile-modal-row d-flex align-items-center">
          <div class="modal-row-content d-flex align-items-center w-100">
            <div class="mobile-modal-row-left">
              <input
                type="text"
                class="mobile-modal-input open-sans-font"
                v-model="cx_searchText"
                placeholder="Pesquise um serviço farmaceutico"
              />
            </div>
            <div class="mobile-modal-row-right d-flex justify-content-end">
              <button class="mobile-cancel-button open-sans-font" v-on:click="toogleSearchModal">
                Cancelar
              </button>
            </div>
          </div>
        </div>
        <div
          class="mobile-modal-row d-flex align-items-center"
          v-for="serviceDefaultName in filterServiceDefaultNames()"
          v-bind:key="serviceDefaultName.id"
          v-on:click="selectServiceDefaultName(serviceDefaultName)"
        >
          <div class="modal-row-content d-flex align-items-center w-100">
            <div class="mobile-modal-row-left">
              <div class="name-option open-sans-font">
                {{ serviceDefaultName.search_name }}
              </div>
            </div>
            <div class="mobile-modal-row-right">
              <div class="info-option open-sans-font">
                <div class="title-info open-sans-font">Valor Médio</div>
                {{ formatCurrency(serviceDefaultName.avg_price) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SelectServiceDefaultNames from "@/components/Util/SelectServiceDefaultNames/SelectServiceDefaultNames";
export default SelectServiceDefaultNames;
</script>

<style lang="scss">
@import "SelectServiceDefaultNames.scss";
</style>
